import type {DataLoadStatus, Prize} from 'api/types';
import {loadReducer} from 'services/utils';
import type {LoadAction} from 'services/utils/redux/actions';

export type PrizeState = DataLoadStatus<Prize>;

export type PrizeAction_Load = {
  type: 'LOAD_PRIZE';
} & LoadAction<Prize>;

export type PrizeAction_Saved = {
  type: 'SAVED_PRIZE';
  payload: {data: Prize};
};

export type PrizeAction_Deleted = {
  type: 'DELETED_PRIZE';
};

export type PrizeAction =
  | PrizeAction_Load
  | PrizeAction_Saved
  | PrizeAction_Deleted;

export const PrizeDefaultState: PrizeState = {status: 'NotLoaded'};

export const prizeReducer = (
  state: PrizeState = PrizeDefaultState,
  action: PrizeAction,
): PrizeState => {
  switch (action.type) {
    case 'LOAD_PRIZE': {
      return loadReducer(state, action);
    }
    case 'SAVED_PRIZE': {
      return {status: 'Loaded', data: action.payload.data};
    }
    case 'DELETED_PRIZE': {
      return state;
    }
    default: {
      return state;
    }
  }
};
